import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "empower-pop-content"
};
const _hoisted_2 = {
  class: "empower-pop-text"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
import { computed, reactive } from 'vue';
import PopUp from '@/components/popup/PopUp.vue';
import { showToast } from 'vant';
import { useStore } from 'vuex';
import { setCustomerConsents } from '@/models/api/orderConfirmApi';
import constants from '@/constants';
import { useLess } from '@/models/hooks';
import { useI18n } from 'vue-i18n';
import { Bridge } from '@/utils/bridge';
import { useRouter } from 'vue-router';
export default {
  __name: 'ShoppingAuthorizationPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:show', 'close', 'confirm'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      IMAGE_URL
    } = constants;
    const {
      t
    } = useI18n();
    const router = useRouter();
    useLess('views/spc/orderConfirm/components/ShoppingAuthorizationPopup.less');
    const CHECKED_SVG = `${constants.IMAGE_URL}assets/svg/checked.svg`;
    const UN_CHECKED_SVG = `${constants.IMAGE_URL}assets/svg/notChecked.svg`;
    const store = useStore();
    const checkedStates = reactive({
      AllowCustomerInfoCollectionCheck: false,
      AllowAccountInfoCollectionCheck: false
    });
    const showVal = computed({
      get: () => props.show,
      set: val => {
        emit('update:show', val);
      }
    });
    const jumpToPage = () => {
      router.push({
        name: 'termStatement',
        query: {
          title: 'USE_CONDITION_FOR_AGS'
        }
      });
    };
    const confirm = async () => {
      if (!checkedStates.AllowCustomerInfoCollectionCheck || !checkedStates.AllowAccountInfoCollectionCheck) {
        showToast({
          message: t('modules.checkout.ORDER_CAN_NOT_PAY_WITHOUT_AUTH'),
          className: 'a-toast'
        });
        showVal.value = true;
      } else {
        try {
          await setCustomerConsents({
            consentType: 'Order',
            consentStatus: constants.CUSTOMER_CONSENT.TRUE
          });
          store.commit('checkout/setIsAuthorize', true);
          showToast({
            message: t('modules.checkout.AUTHORIZATION_SUCCESSFUL'),
            icon: constants.SUCCESS_ICON_IMAGE_URL,
            className: 'a-toast'
          });
          emit('confirm');
          showVal.value = false;
        } catch (error) {
          console.error(error, 'SetCustomerConsent---api---error');
        }
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PopUp, {
        show: showVal.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => showVal.value = $event),
        btnConfirmText: _unref(t)('modules.checkout.AUTHORIZE_NOW'),
        isManualClose: "",
        title: _unref(t)('modules.checkout.GLOBAL_STORE_NOTIFICATION_AND_ORDER_AUTHORIZATION'),
        onConfirm: confirm
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(_unref(t)('modules.checkout.CUSTOMER_AUTHENTICATION_ACKNOWLEDGE')), 1), _createElementVNode("span", {
          class: "link",
          onClick: jumpToPage
        }, _toDisplayString(_unref(t)('modules.checkout.USAGE_CONDITIONS')), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)('modules.checkout.CUSTOMER_AUTHENTICATION_FOR_GS_PURCHASE')), 1)]), _createElementVNode("div", {
          class: "empower-pop-term",
          onClick: _cache[0] || (_cache[0] = () => checkedStates.AllowCustomerInfoCollectionCheck = !checkedStates.AllowCustomerInfoCollectionCheck)
        }, [_createElementVNode("img", {
          class: _normalizeClass({
            checked: checkedStates.AllowCustomerInfoCollectionCheck
          }),
          src: checkedStates.AllowCustomerInfoCollectionCheck ? CHECKED_SVG : UN_CHECKED_SVG,
          alt: ""
        }, null, 10, _hoisted_3), _createTextVNode(" " + _toDisplayString(_unref(t)('modules.checkout.ALLOW_AMAZON_WEBSITES_COLLECT_USE_INFO_INCLUDING')), 1)]), _createElementVNode("div", {
          class: "empower-pop-term",
          onClick: _cache[1] || (_cache[1] = () => checkedStates.AllowAccountInfoCollectionCheck = !checkedStates.AllowAccountInfoCollectionCheck)
        }, [_createElementVNode("img", {
          class: _normalizeClass({
            checked: checkedStates.AllowAccountInfoCollectionCheck
          }),
          src: checkedStates.AllowAccountInfoCollectionCheck ? CHECKED_SVG : UN_CHECKED_SVG,
          alt: ""
        }, null, 10, _hoisted_4), _createTextVNode(" " + _toDisplayString(_unref(t)('modules.checkout.INFO_WILL_USED_CLEARANCE_REAL_NAME_DECLARATION')), 1)])])]),
        notes: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.CHANGE_AUTH_STATUS_IN_MY_AFTERWARDS')), 1)]),
        _: 1
      }, 8, ["show", "btnConfirmText", "title"]);
    };
  }
};